import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              This chapter provided insight into how unplanned and rapid
              urbanization can affect a region&rsquo;s surface temperature. The
              study sets out to understand how LST leads to the development of
              UHI and further affects the residents&rsquo; health and welfare.
              The research also provided a practical example of how the study of
              UHI can be performed supplemented with an estimation of LST and
              development of LU. The key purpose of this study was to provide
              the effects of UHI and suggest mitigation measures for reducing
              them. One of the most important take away points from this chapter
              is that a rise in impervious surfaces can significantly alter the
              microclimate of a region in terms of LST that further instigates
              or increases the intensity and frequency of positive UHIs.
              Altogether, unplanned and unregulated urbanization with lesser
              vegetation, open spaces, and water bodies can lead to a rise in
              warming throughout the urban area and increases heat-related
              issues among the residents. Therefore, it can be concluded that
              plantation of dense vegetation rather than fragmented ones and the
              presence of water bodies throughout the urban area can solve the
              problem of high surface temperature and ill-effects of UHIs. Open
              spaces in the city serve as regions where high pollutants and
              other dust particles can be displaced properly and avoid them
              being blocked within the localities in a city, thus creating
              breathing spaces. The study was complemented by practical example
              performed for KMA with 10 km buffer, and it was observed that the
              study area has experienced tremendous growth in terms of
              impervious surface on the cost of vegetation and others category
              that has led to an average rise of 10.6<sup>◦</sup>C in surface
              temperature.
            </p>
            <p>
              Further, the relationship between LU and LST was derived, and it
              was inferred that urban areas and barren grounds contribute to
              high, vegetation corresponds to moderate, and water bodies
              corresponds to low surface temperatures. The final part of this
              chapter deals with the suggestion of a few mitigation measures to
              tackle the rising issue of UHI. The information provided in this
              chapter and other research findings can act as background data and
              suggestions to the urban planners, stakeholders, and
              decision-makers to reformulate the older and develop new policies
              for achieving sustenance.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
